import domain from './domain';
import { resetTaskCategoryGroups } from './events';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TaskCategoryGroupListItemResource } from 'dy-frontend-http-repository/lib/modules/TaskCategoryGroup/resources';

// Task category groups
export const $taskCategoryGroups = domain
    .createStore<CollectionResource<TaskCategoryGroupListItemResource, {}> | null>(null)
    .reset(resetTaskCategoryGroups);
